// Fiscal years (April - March) are written "2026-27" in document numbering.

/** "2026-27" for the fiscal year that starts in `startYear`. */
export function formatFiscalYear(startYear: number): string {
  return `${startYear}-${String(startYear + 1).slice(-2)}`
}

/** The fiscal year `date` falls in. */
export function currentFiscalYear(date: Date = new Date()): string {
  return formatFiscalYear(date.getMonth() >= 3 ? date.getFullYear() : date.getFullYear() - 1)
}

/** The current fiscal year and the ones around it, oldest first. */
export function fiscalYearOptions(date: Date = new Date(), before = 2, after = 2): string[] {
  const start = Number(currentFiscalYear(date).slice(0, 4))
  return Array.from({ length: before + after + 1 }, (_, i) => formatFiscalYear(start - before + i))
}

/** Older configs saved "2026-2027"; shows that as "2026-27" and leaves anything else as it is. */
export function normalizeFiscalYear(value: string): string {
  const match = String(value ?? '').trim().match(/^(\d{4})\s*-\s*(\d{4})$/)
  if (!match) return String(value ?? '').trim()
  return Number(match[2]) === Number(match[1]) + 1 ? formatFiscalYear(Number(match[1])) : `${match[1]}-${match[2]}`
}
